import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-network-icon',
  templateUrl: 'network-icon.component.html'
})
export class NetworkIconComponent {
  constructor() {}
}
